import type { IOperatingEntity } from '@boc/core';

export const boc: IOperatingEntity = {
  name: 'Band of Capes',
  legalEntity: 'Band of Capes Pvt. Ltd.',
  contactEmail: 'hello@bandofcapes.com',
  store: {
    address: 'Band of Capes, Pune, India',
    gmaps: 'https://maps.app.goo.gl/qPdTE4o2BB36ijHeA',
  },
};

export const mantiq: IOperatingEntity = {
  name: 'Mantiq Corp',
  legalEntity: 'Mantiq Corp Fz LLE',
  contactEmail: 'hello@mantiqcorp.com',
  store: {
    address: 'Mantiq Corp, Dubai, UAE',
    gmaps: 'https://maps.app.goo.gl/smBZjTcNKKCVL5JVA',
  },
};
